<template>
  <div class="market-price-gauge-container">
    <h6 class="gauge-title">{{ title }}</h6>
    <div class="gauge-wrapper">
      <circle-progress :percent="priceIndex" :viewport="true" :show-percent="false" :size="250" :border-width="30" :border-bg-width="30" fill-color="#00BCD4" empty-color="#E0E0E0" />
      <div class="gauge-text-overlay">
        <div class="price-index-text">{{ priceIndex.toFixed(1) }}</div>
        <div class="price-index-label">{{ $t('dashboard.marketOverview.priceIndex') }}</div>
      </div>
    </div>
    <div class="price-details">
      <div class="adata-price">
        <div class="price-value">{{ formatPrice(adataPrice) }}</div>
        <div class="price-label">{{ $t('dashboard.marketOverview.adataMedian') }}</div>
      </div>
      <div class="market-price">
        <div class="price-value">{{ formatPrice(marketPrice) }}</div>
        <div class="price-label">{{ $t('dashboard.marketOverview.competitorsMedian') }}</div>
      </div>
    </div>
    <div v-if="isCompetitive" class="competitive-tag">
      <i class="fas fa-info-circle"></i> {{ $t('dashboard.marketOverview.competitive') }}
    </div>
    <div v-if="recommendation" class="pricing-recommendation">
      <i class="fas fa-thumbs-up"></i> {{ recommendation }}
    </div>
  </div>
</template>

<script>
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";

export default {
  name: 'MarketPriceGauge',
  components: {
    CircleProgress
  },
  props: {
    adataPrice: {
      type: Number,
      required: true
    },
    marketPrice: {
      type: Number,
      required: true
    },
    priceIndex: {
      type: Number,
      required: true
    },
    isCompetitive: {
      type: Boolean,
      required: true
    },
    recommendation: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    formatPrice(price) {
      if (price === null || price === undefined) {
        return 'N/A';
      }
      return `$${price.toFixed(2)}`;
    }
  }
};
</script>

<style scoped>
.market-price-gauge-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: relative;
  min-height: 300px; /* Adjust as needed */
  justify-content: space-between;
}

.gauge-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.gauge-wrapper {
  position: relative;
  width: 250px; /* Same as circle-progress size */
  height: 250px; /* Same as circle-progress size */
  margin-bottom: 15px;
}

.gauge-text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price-index-text {
  font-size: 2.5rem;
  font-weight: bold;
  color: #00BCD4; /* Active gauge color */
}

.price-index-label {
  font-size: 0.9rem;
  color: #666;
}

.price-details {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}

.adata-price, .market-price {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.price-label {
  font-size: 0.8rem;
  color: #666;
}

.competitive-tag {
  background-color: #00BCD4; /* Blue background */
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
}

.pricing-recommendation {
  background-color: #e0f7fa; /* Light blue background */
  color: #00796b; /* Darker green/blue text */
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 0.9rem;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 90%; /* Adjust width as needed */
}

.pricing-recommendation i {
  font-size: 1.2rem;
}
</style>
